import { annotate } from 'rough-notation';
window.axios = require('axios');
require('./components/logger.js');
const Mustache = require("mustache");

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

const getPath = ()=>{
    return window.location.pathname;
};

const isProduction = ()=>{
    return (_APP && _APP.STAGE && _APP.STAGE === "production");
}

const isMobile = ()=>{
    var isMobile = false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
        isMobile = true;
    }
    return isMobile;
};

const detectCountry = ()=>{
    if(ct){
        var browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return ct.getCountryForTimezone(browserTZ);
    }
    return null;
};

const initApp = ()=>{
    console.log("Loading Base App - " + (isProduction() ? "Production" : "Development"));
    
    initBlogSearchForm(); // Initialize Blog Search Form
    initializeHighlighting(); // Initialize Highlighting Styles
    initContactFormWidget(); // Initialize Animation for the Elfsight Contact Form
    initEmailAndPhoneReplacements(); // Initialize Email and Phone Replacements
    autoScrollSection();
    

    // Initialize Tooltips
    (()=>{
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return $(tooltipTriggerEl).tooltip();
    })})();
    
    identifyEnchargeUser(); // Identify Encharge User
    initTools();
};

const autoScrollSection = ()=>{
    var hash = window.section;
    if(hash && hash.length > 0){
        var offset = 0;
        if ( $('.header').length ) {
            offset = $('.header').height();
        }
        var $el = $(hash);
        if($el.length > 0){
            var newOffset = $el.offset().top - offset;
            if(newOffset){
                $('html').animate({
                    scrollTop: newOffset
                }, 700);
            }
        }
    }
};

const manualScrollTo = (id)=>{
    if ( $(id).length > 0 ) {
        var offset = 0;
        if ( $('.header').length ) {
            offset = $('.header').height();
        }
        $('html').animate({scrollTop: $(id).offset().top - offset}, 700);
    }
};

const triggerEnchargeEvent = ()=>{
    if(params.email && params.eid){
        var email = params.email;
        var eid = params.eid;
        var path = getPath();
        var strippedPath = path.replace(/\/$/, ''); // remove last trailing slash
        var lastPart = strippedPath.split('/').pop();
        
        var action = params.action ? params.action : "Onsite Action: "+lastPart;

        console.log("Triggering Event for "+email+" with eid "+eid + " - "+action);
        if(window.EncTracking && window.EncTracking.track){
            window.EncTracking.track(
                {
                    "name": action, 
                    "properties": { 
                        "link": lastPart,
                        "page": path
                    },
                    "user": { 
                        "email": email
                    }
                }
            );
        }
    }
};

const identifyEnchargeUser = ()=>{
    if(params.enchEmail){
        if(window.EncTracking && window.EncTracking.identify){
            EncTracking.identify({ email: params.enchEmail });
            console.debug('Identified visitor with email: ' + params.enchEmail);
        }
    }
};

const initEmailAndPhoneReplacements = ()=>{
      // Email Widget
      $(".emGoesHere").each((i, el)=>{
        $(el).text(atob("c3VwcG9ydEBkdWx5cGFpZC5jb20="));
      });

      // Phone Widget
      var visitorsCountry = detectCountry();
      var phoneNumber = "+1 (650) 445 0900";
      var countryDetected = "US";
      if(visitorsCountry && visitorsCountry.id && visitorsCountry.name){
          console.log("Welcome guest from "+visitorsCountry.id + ", "+visitorsCountry.name);
          countryDetected = visitorsCountry.id;
      }
      if(params.country){
        countryDetected = params.country;
      }
      if(countryDetected=="GB"){
        phoneNumber = "+44 162 820 4000";
      }else{
        phoneNumber = "+1 (650) 445 0900";
      }

      $(".phGoesHere").each((i, el)=>{
        $(el).html($("<a></a>").attr("href", "tel:"+phoneNumber).text(phoneNumber));
      });
};

const initTools = ()=>{
    $('#generatedReminderRow').hide();
    
    $('form.reminderForm').on("submit", function (e) {
        e.preventDefault();
        var el = e.target;
        manualScrollTo("#generatedReminderBookmark");    

        $('#generatedReminder').html("");
        $('#generatedReminder').hide();
        $('#errorAlert').hide();

        $('#generatedReminderRow').fadeIn();
        $('#spinner').fadeIn();

        // Serialize form data
        var formData = $(el).serialize();
        
        // Send form data via Ajax
        $.ajax({
            type: 'POST',
            headers: {          
                Accept: "application/json",         
                "Content-Type": "application/x-www-form-urlencoded"
                },
            url: $(el).data("action"),
            data: formData,
            success: function (data) {
                // Process the returned data
                $('#spinner').hide();
                $('#generatedReminder').html(data.response.transformed_response.content);
                $('#generatedReminder').fadeIn();
            },
            error: function (error) {
                // Handle errors
                $('#spinner').hide();
                // if error status code is 429 (throttled)
                if(error.status === 429){
                    $('#errorMessageContainer').html("Too Many Attempts. Please try again later.");
                    $('#errorAlert').fadeIn();
                }else if(error.responseJSON && error.responseJSON.errors){
                    $('#errorMessageContainer').html("<ul>");
                    var errors = error.responseJSON.errors;
                    console.log(errors);
                    Object.keys(errors).forEach(function (key) {
                        $('#errorMessageContainer').append("<li>"+errors[key][0]+"</li>");
                    });
                    $('#errorMessageContainer').append("</ul>");
                    $('#errorAlert').fadeIn();
                }
            }
        });


    });
};

const initializeHighlighting = ()=>{
    // Source: https://github.com/rough-stuff/rough-notation
    const e1 = $('.hl-underline');
    const e2 = $(".hl-highlight");
    const e3 = $('.hl-double-underline');
    const e4 = $('.blog-details mark');
     
    (e1).each((index, el)=>{
        const color = $(el).attr("data-hl-color") ? $(el).attr("data-hl-color") : "cyan";
        const iter = $(el).attr("data-hl-iterations") ? parseInt($(el).attr("data-hl-iterations")) : 1;
        const a1 = annotate(el, { type: 'underline', color: color,  strokeWidth: 5, iterations: iter, padding: 2, multiline: true });
        a1.show();
    });

    (e2).each((index, el)=>{
        const color = $(el).attr("data-hl-color") ? $(el).attr("data-hl-color") : "yellow";
        const iter = $(el).attr("data-hl-iterations") ? parseInt($(el).attr("data-hl-iterations")) : 2;
        const a2 = annotate(el, { type: 'highlight', color: color, strokeWidth: 3, iterations: iter, multiline: true, padding: 4 });
        a2.show();
    });

    (e3).each((index, el)=>{
        const color = $(el).attr("data-hl-color") ? $(el).attr("data-hl-color") : "#007bff";
        const iter = $(el).attr("data-hl-iterations") ? parseInt($(el).attr("data-hl-iterations")) : 2;
        const a3 = annotate(el, { type: 'underline', color: color,  strokeWidth: 2, iterations: iter, padding: 2, multiline:true });
        a3.show();
    });

    (e4).each((index, el)=>{
        const color = $(el).attr("data-hl-color") ? $(el).attr("data-hl-color") : "cyan";
        const iter = $(el).attr("data-hl-iterations") ? parseInt($(el).attr("data-hl-iterations")) : 1;
        const a2 = annotate(el, { type: 'highlight', color: color, strokeWidth: 2, iterations: iter, multiline: true, padding: 2 });
        a2.show();
    });
};

const initContactFormWidget = ()=>{
    if(isProduction() && !isMobile()){
        setTimeout(()=>{
            var tag = document.createElement("script");
            tag.src = "https://static.elfsight.com/platform/platform.js";
            tag.setAttribute("data-use-service-core", "true");
            tag.setAttribute("defer", "true");
            document.getElementsByTagName("head")[0].appendChild(tag);
            console.log("Lazy loaded Elfsight widget");
        }, 1000);
        $("a[data-elfsight-show-form]").each((index, el)=>{
            $(el).attr("href", "javascript:;");
        });
    }
    
    const initContactButtonWidget = ()=>{
        var documentOffsetHeight = document.body.offsetHeight;
        var windowHeight = $(window).height();
        $(window).off('scroll.contact');
        $(window).on('scroll.contact', function() {
            if($(this).scrollTop() > (documentOffsetHeight-1000) ){
                $('[class*="FloatingButton__FloatingButtonContainer"]').fadeOut();
            }else if ($(this).scrollTop() > (windowHeight + 200) ){
                $('[class*="FloatingButton__FloatingButtonContainer"]').fadeIn();
            } else{
                $('[class*="FloatingButton__FloatingButtonContainer"]').fadeOut();
            }
        });
    };
    initContactButtonWidget();
    $(window).on('resize', function() {
        initContactButtonWidget();
    });
};

const initBlogSearchForm = () =>{
    // Initialize Search Form
    var form = document.getElementById('searchForm');
    if(form){
        $(form).on("submit", (e)=>{
            e.preventDefault();
        
            var form = e.currentTarget;
            var $form = $(form);
            var query = $form.find("[name='query']").val();
            if(query.length > 1){
                console.log("Sending to "+$form.attr("action") +" , query = "+query);
                window.location = $form.attr("action") + "?query=" + encodeURIComponent(query);
            }
            return false;
        });
    }
};

const initBlogSearchApp = () =>{
    console.log("Loading Blog Search App");
    let query = params.query;
    if(query==null){
        query = "";
    }else{
        $("h2.lead").append(": "+query);
    }
    
    const template = document.getElementById('blog-template').innerHTML;
    const templateNoResults = document.getElementById('blog-template-no-results').innerHTML;
    console.log("Query: "+query);
    axios({
        method: 'GET',
        dataType: "json",
        url: "/index.json"
    }).then(response =>{
        console.log("Received response.");
        if(response && response.data){
            let data = response.data;
            let needle = query.toLowerCase();
            let results = [];

            data.forEach((el)=>{
                let title = el.title;
                let excerpt = el.snippet;
                let link = el.link;
                if(title.toLowerCase().includes(needle) || excerpt.toLowerCase().includes(needle) || link.toLowerCase().includes(needle) ){
                    results.push(el);
                }
            });

            var $container = $("#list-of-posts");
            if(results.length==0){
                var rendered = Mustache.render(templateNoResults, {});
                $container.append(rendered);
            }else{
                results.forEach((el)=>{
                    var data = {
                        "post-url": el.link,
                        "post-title": el.title,
                        "post-cover-image": el.cover,
                        "post-excerpt": el.snippet,
                    };
                    var rendered = Mustache.render(template, data);
                    $container.append(rendered);
                });
            }
            
        }
    })
    .catch(error => {
        console.log(error);
    });
    //

};

(function($) {
    $(window).on('load', function () {
        initApp();
        const path = getPath();
        if(path.startsWith("/blog/search")){
            initBlogSearchApp();
        }
        if(path.startsWith("/redirect") || path.startsWith("/landing")){
            triggerEnchargeEvent(); 
        }
    });

}(jQuery));